import GUIDUtil from "/lib/html5-software-library/src/ranj/util/GUIDUtil";
import CookieUtil from "/lib/html5-software-library/src/ranj/util/CookieUtil";

/**
* PlaySession.js
* 
* Created on Oct 9, 2013, 3:26:07 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class PlaySession {
	constructor() {
		this.sessionID = GUIDUtil.generateGUID();
		this.deviceID = CookieUtil.getCookie("deviceID");
		if (this.deviceID === -1) {
			var randomString = GUIDUtil.generateGUID();
			CookieUtil.setCookie("deviceID", randomString, 365);
			this.deviceID = randomString;
		}
	}
}